import { render, staticRenderFns } from "./Staging-New-Request-Step2.vue?vue&type=template&id=bfd6e2bc&scoped=true&"
import script from "./Staging-New-Request-Step2.vue?vue&type=script&lang=js&"
export * from "./Staging-New-Request-Step2.vue?vue&type=script&lang=js&"
import style0 from "./Staging-New-Request-Step2.vue?vue&type=style&index=0&id=bfd6e2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd6e2bc",
  null
  
)

export default component.exports